import styled from "styled-components";

export const Sidebar = styled("div")`
  display: flex;
  flex-direction: column;
  width: 310px;
`;

export const SidebarTitle = styled("div")`
  height: 46px;
  margin: 0 0 9px;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: center;
  color: #2e3d49;
`;

export const SidebarMoreInfo = styled("div")`
  height: 15px;
  margin-bottom: 9px;
  font-family: Manrope;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2e3d49;
`;

interface ISidebarSupp {
  isSiteDetails?: boolean;
}

export const SidebarSupp = styled("div")`
  display: flex;
  flex-direction: column;
  line-height: 23px;
  padding: 0px;
  flex-grow: 1;
  min-height: 340px;

  ${(props: ISidebarSupp) =>
        !props.isSiteDetails
    && `                             
    align-items: start;             
    padding: 0px 15px;
    border-radius: 3px;    
    background-color: #ffffff;
`}
`;

export const SupText = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: bold;
`;
